import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

export default function Footer(){
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <h4>Liberty Street Food GmbH</h4>
          <p>Smashburger Catering · NRW & deutschlandweit</p>
        </div>
        <div>
          <h5>Kontakt</h5>
          <p>info@libertystreetfood.de · +49 15511522559</p>
        </div>
        <div>
          <h5>Rechtliches</h5>
          <Link to="/impressum">Impressum</Link><br/>
          <Link to="/agb">AGB</Link><br/>
          <Link to="/datenschutz">Datenschutz</Link>
        </div>
      </div>
      <div className="copyright">© {new Date().getFullYear()} Liberty Street Food GmbH</div>
    </footer>
  );
}
